

















import { Component, Prop, Product, Vue } from "@zoovu/runner-browser-api";
import { ProductClickoutLinkView } from "@zoovu/runner-web-design-base";
import { State } from "vuex-class";

@Component({
  name: "ProductClickoutLinkView",
  mixins: [ProductClickoutLinkView]
})
export default class ProductClickoutLinkViewExtended extends Vue {
  @Prop()
  private product!: Product;

  private offerUrl: string = this.product.offerUrl;

  @State
  productClickoutDisabled!: boolean;

  public updateOfferUrl() {
    const trackedOfferUrl = this.product.getTrackedOfferUrl();
    this.offerUrl = trackedOfferUrl;
    (this.$refs.anchor as HTMLElement).setAttribute("href", trackedOfferUrl); // it is important to change link without waiting for vue next tick!
  }

  public onLeftMouseDown() {
    this.product.notifyUserMovedToProductDetailsPage();
  }

  checkDisabled(event) {
    if (this.productClickoutDisabled) {
      event.preventDefault();
    }
  }
}
